module.exports = __webpack_public_path__ + "img/Dantam Makeover 24.71161aee.jpg";